import { render, staticRenderFns } from "./UploadContentDialog.vue?vue&type=template&id=6df85afc"
import script from "./UploadContentDialog.vue?vue&type=script&lang=ts"
export * from "./UploadContentDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports